import { createSlice } from "@reduxjs/toolkit";

export const intialReferrerLocalState = {
  name: "",
  email: "",
  phone: "",
  notes:""
};

const initialState = {
  referrers: [],
  referrerDetail: null,
  newReferrerLocal: intialReferrerLocalState,
  pagination: {},
  isAddReferrerSuccess: false,
  isUpdateReferrerSuccess: false,
  isDeleteResponseSuccess: false,
};

export const referrerSlice = createSlice({
  name: "referrer",
  initialState,
  reducers: {
    getAllReferrerAction: (state) => {},
    setAllReferrerAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.referrers = payload;
      state.pagination = pagination;
    },

    addReferrerAction: (state, { payload }) => {},
    setAddReferrerResponse: (state, { payload }) => {
      state.isAddReferrerSuccess = payload;
    },

    updateReferrerAction: (state, { payload }) => {},
    updateReferrerResponse: (state, { payload }) => {
      state.isUpdateReferrerSuccess = payload;
    },

    deleteReferrerAction: (state, { payload }) => {},
    setDeleteReferrerResponse: (state, { payload }) => {
      state.isDeleteResponseSuccess = payload;
    },

    setNewReferrerLocal: (state, action) => {
      state.newReferrerLocal = action.payload;
    },
    resetNewReferrerLocal: (state) => {
      state.newReferrerLocal = intialReferrerLocalState;
    },
  },
});

const {
  getAllReferrerAction,
  setAllReferrerAction,
  addReferrerAction,
  setAddReferrerResponse,
  updateReferrerAction,
  updateReferrerResponse,
  deleteReferrerAction,
  setDeleteReferrerResponse,
  setNewReferrerLocal,
  resetNewReferrerLocal,
} = referrerSlice.actions;

export {
    getAllReferrerAction,
  setAllReferrerAction,
  addReferrerAction,
  setAddReferrerResponse,
  updateReferrerAction,
  updateReferrerResponse,
  deleteReferrerAction,
  setDeleteReferrerResponse,
  setNewReferrerLocal,
  resetNewReferrerLocal
}

export default referrerSlice.reducer;
